import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/styles/global.css';
import './index.css';

// 挂载应用到根节点
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element. Please ensure index.html contains <div id="root"></div>.');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);